import { GetVideoByRound } from 'hooks'
import { CommonVideosList } from 'page-components/videos'
import React from 'react'
import { useParams } from 'react-router-dom'

export const RoundUploadedVideoList = () => {
  const { round, competitionId } = useParams()
  const {
    data,
    loading,
    setData,
    loadMore,
    hasMore,
  } = GetVideoByRound(competitionId, round);

  return (
    <CommonVideosList
      showSearchBar={false}
      data={data}
      loading={loading}
      loadMore={loadMore}
      setData={setData}
      hasMore={hasMore}
    />
  )
}
